// extracted by mini-css-extract-plugin
export default {"container":"AddGift_container__CV8iG","heading":"AddGift_heading__Qg5KD","form":"AddGift_form__XI1QK","buttonContainer":"AddGift_buttonContainer__j04Zp"};